module.exports = __webpack_public_path__ + "img/hybrid.6fc1b985.png";